module.exports = __webpack_public_path__ + "img/ent4.6cb88d7b.png";